import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {IButton} from '../../../../shared/card/card.component';
import {OrderService} from '../../../Services/order.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import * as moment from 'moment';
import {environment} from '../../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateCustomParserFormatter} from '../../../../shared/Services/NgbDateCustomParserFormatter';
import {OrderCustomRow} from '../../../../back-office/Models/OrderCustomRow';
import {Discount} from '../../../../back-office/Models/Discount';
import { Order } from 'src/app/back-office/Models/Order';
import { FabricCollection } from 'src/app/back-office/Models/FabricCollection';
import { Option } from 'src/app/back-office/Models/Option';
import { Property } from 'src/app/back-office/Models/Property';
import {OrderItem} from '../../../../back-office/Models/OrderItem';
import {OrderItemProduct} from '../../../../back-office/Models/OrderItemProduct';
import {OrderItemProductFabricCollection} from '../../../../back-office/Models/OrderItemProductFabricCollection';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {throwError, catchError} from 'rxjs';
import {NgForm} from '@angular/forms';
import { HttpResponse } from '@angular/common/http';
import {carpetSizeLabel} from '../../../../helpers/carpet-price';


@Component({
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
  ],
  selector: 'app-view-quote',
  templateUrl: './view-order.component.html',
  styleUrls: ['./view-order.component.scss']
})
export class ViewOrderComponent implements OnInit {

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
    private translator: TranslateService,
    private router: Router,
    public auth: AuthenticationService,
    private helper: Helper,
  ) {
  }
  private options = [];

  public specialButton: IButton[] = [];
  public specialButtonArray = [];

  public order: Order;
  public orderId: number;
  public editCustomRow = false;
  public orderStatus;
  public delivery;
  public remark;
  public lastOrders = [];
  public baseUrl = environment.apiUrl;
  public cloneOrderItemProducts = [];
  public cloneOrder: Order;
  public isEditableAfterCancel = true;
  public customRows: OrderCustomRow[] = [];
  private dealerPdfOrderId: number | null = null;
  private quoteDealerPdfRequested: boolean = false;
  @ViewChild('cancelModal', {static: false}) cancelModal = null;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('passwordModal', {static: false}) passwordModal = null;
  @ViewChild('passwordModalForm', {static: false}) passwordModalForm: NgForm;
  public discount = new Discount();
  public isCustomerPrice = true;
  public toggleCustomerPriceClass = 'fa-toggle-off';
  public dealerPassword: string;
  public priceItemHasError = false;
  public isQuote = false;
  public quoteToOrder = false;
  public selectedCustomPrice = true;

  protected readonly parseInt = parseInt;
  ngOnInit() {
    this.isQuote = this.route.snapshot.url[0]?.path === 'quote';;
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.orderId = params['id'];
        const request = this.isQuote ? this.orderService.getQuoteOrder(this.orderId) : this.orderService.getOrder(this.orderId);
        request.subscribe((resp) => {
          this.order = resp;
          this.prepareOrder(this.order);
          this.prepareDiscount(this.order);
          if (this.order.status !== Order.CANCELLED.key) {
            this.isEditableAfterCancel = true;
          } else {
            this.isEditableAfterCancel = false;
          }

          this.addSpecialButtons();

          this.cloneOrder = JSON.parse(JSON.stringify(this.order));
          this.orderStatus = this.cloneOrder.status;
          // this.prepareStatus();
          this.delivery = this.cloneOrder.expectedDeliveryWeek;
          this.delivery = moment(this.delivery, 'YYYY/MM/DD');
          this.delivery = {
            'year': +this.delivery.format('YYYY'),
            'month': +this.delivery.format('M'),
            'day': +this.delivery.format('D')
          };
          // set amounts to zero
          this.cloneOrder.orderItems.forEach((orderItem, index) => {
            if (orderItem.orderItemProducts) {
              orderItem.orderItemProducts.forEach((orderItemProduct, key) => {
                this.cloneOrder.orderItems[index].orderItemProducts[key].amount = 0;
              });
            }
          });
          this.order.orderItems.forEach(orderItem => {
            if (orderItem.orderItemProducts) {
              orderItem.orderItemProducts.forEach(orderItemProduct => {
                const clone = Object.assign({}, orderItemProduct);
                this.cloneOrderItemProducts.push(clone);
              });
            }
          });
          // fix custom fabrics
          this.order.orderItems.forEach(orderItem => {
            let lastCustomFabric = null;

            orderItem.orderItemProducts.forEach((orderItemProduct) => {
              const fabricCollections = orderItemProduct?.orderItemProductFabricCollections;
              if (!fabricCollections?.length) {
                return;
              }

              const currentFabric = fabricCollections[0];
              const fabricCollection = currentFabric?.fabricCollection as FabricCollection;

              if (fabricCollection?.isCustom) {
                if (currentFabric?.fabricName || currentFabric?.fabricColorName) {
                  lastCustomFabric = currentFabric;
                }

                if (lastCustomFabric) {
                  currentFabric.fabricName = lastCustomFabric.fabricName;
                  currentFabric.fabricColorName = lastCustomFabric.fabricColorName;
                }
              }
            });
          });
        });
      }
    });
  }

  getOrderItem() {
    this.orderService.getOrder(this.orderId).subscribe((resp) => {
      this.order = resp;
      if (this.order.customRows && this.order.customRows.length > 0) {
      } else {
        this.editCustomRow = false;
      }
      this.prepareOrder(this.order);
    });
  }

  requestNewService() {
    return this.router.navigateByUrl('dealer-system/order/' + this.orderId + '/service-request');
  }

  calFunction(method: string) {
    this[method]();
  }

  goToEditOrder() {
    this.router.navigateByUrl('/dealer-system/order/' + this.orderId + '/edit');
  }

  showCancelModal() {
    this.cancelModal.show();
  }

  cancelOrder() {
    this.orderService.cancelOrder(this.orderId).subscribe((resp) => {
      this.hideButtonsAfterCancelOrder();
      this.cancelModal.hide();
      this.getOrderItem();
    });
  }

  hideButtonsAfterCancelOrder() {
    const NewSetOfSpecialButton = [];
    this.specialButton.forEach((Link) => {
      if (Link.key !== 'split_order' && Link.key !== 'edit_order' && Link.key !== 'cancel_order') {
        NewSetOfSpecialButton.push(Link);
      }
    });
    this.specialButton = NewSetOfSpecialButton;
    this.isEditableAfterCancel = false;
  }

  getAllTotal(order: Order): void {
    if (!Helper.isDefined(order.orderItems)) {
      return;
    }

    order.orderItems.forEach(orderItem => {
      orderItem.totalArticleDealerPrice = this.calculateOrderItemTotal(orderItem);
    });
  }

  private calculateOrderItemTotal(orderItem: OrderItem): number {
    let totalPrice = 0;

    orderItem.orderItemProducts.forEach(product => {
      totalPrice = Helper.bcAdd(
        totalPrice,
        this.calculateBaseProductPrice(product),
        this.calculateFabricPrice(product),
        this.calculatePackagePrice(product),
        this.calculateOptionsPrice(orderItem, product)
      );
    });

    return totalPrice;
  }

  private calculateBaseProductPrice(product: OrderItemProduct): number {
    const totalCost = product.totalCost;
    return this.isCustomerPrice
      ? totalCost.totalCustomerCost
      : totalCost.totalDealerPrice;
  }

  private calculateFabricPrice(product: OrderItemProduct): number {
    if (!product.orderItemProductFabricCollections?.[0]) {
      return 0;
    }

    const fabricCollection = product.orderItemProductFabricCollections[0];
    return this.isCustomerPrice
      ? fabricCollection.totalCost.totalCustomerCost
      : fabricCollection.totalCost.totalDealerPrice;
  }

  private calculatePackagePrice(product: OrderItemProduct): number {
    if (!product.orderItemProductPackages) {
      return 0;
    }

    return product.orderItemProductPackages.reduce((total, pkg) => pkg.orderItemProductPackageProducts.reduce((pkgTotal, pkgProduct) => {
        const price = this.isCustomerPrice
          ? pkgProduct.totalCost.totalCustomerCost
          : pkgProduct.totalCost.totalDealerPrice;
        return Helper.bcAdd(pkgTotal, price);
      }, total), 0);
  }

  private calculateOptionsPrice(orderItem: OrderItem, product: OrderItemProduct): number {
    const options = this.calculateOptions(orderItem, product);
    if (!options) {
      return 0;
    }

    return options.reduce((total, option) => Helper.bcAdd(total, this.optionSubtreeTotal(option, product)), 0);
  }

  orderPdf() {
    this.orderService.getPdf(this.orderId, 'customer').subscribe((resp) => {
      if (resp && typeof resp === 'object') {
        this.helper.createDownloadLink(resp.url, resp.filename);
      }
    });
  }

  orderDealerPdf() {
    this.dealerPdfOrderId = this.orderId;
    if (this.auth.isDealer()) {
      this.passwordModal.show();
    }

  }
  customFabricPackagingLabel() {
    this.orderService.getCustomFabricPackagingPdf(this.orderId).subscribe((resp) => {
    });
  }


  /**
   * Rugs are the only line that carries dimensions — a sofa leaves widthCm/lengthCm
   * null — so the label doubles as the "is this a carpet" test and returns null for
   * everything else, which interpolates to nothing.
   */
  carpetSizeLabel = carpetSizeLabel;

  calculateOptions(orderItem: OrderItem, orderItemProduct: OrderItemProduct) {
    const productOptions = this.options[orderItemProduct.id];
    if (Helper.isDefined(productOptions)) {
      return productOptions;
    }
  }

  lastOrderCalc(order: Order) {
    if (order.lastOrder) {
      if (this.lastOrders.findIndex(lastOrder => order.lastOrder.id === lastOrder.id) === -1) {
        this.lastOrders.push(order.lastOrder);
      }
      this.prepareOrder(order.lastOrder);
      this.lastOrders = Object.values(this.lastOrders);
    }
  }

  checkHasFabric(orderItemProductFabricCollection: OrderItemProductFabricCollection) {
    return (orderItemProductFabricCollection.fabricCollection !== null && orderItemProductFabricCollection.fabric !== null && orderItemProductFabricCollection.fabricColor !== null)
      || (orderItemProductFabricCollection.fabricCollection !== null && orderItemProductFabricCollection.fabricName  && orderItemProductFabricCollection.fabricColorName);
  }

  checkType(option) {
    return (!option.children || option.type === Option.OPTION_TYPE_SELECT);
  }

  /**
   * An option is shown inline (comma separated, on its parent's line) when its own `parent`
   * label is the parent option's selected value; otherwise it starts its own labelled line.
   * Same rule as the API report template, see the #optionCell template.
   */
  isInlineOption(option, parentCurrent): boolean {
    return !!parentCurrent && option.parent === parentCurrent;
  }

  /**
   * An option's price for the article subtotal is the sum of the option rows the template
   * actually prices, walked over the whole subtree: nested options such as a pillow under
   * "Contrast piping" or a leg size under "Different legs" carry the price on their own row.
   * checkType() is the same gate the Price and Total columns use, and it blanks a non-Select
   * option that has children, because that parent's own charge is already inside its child's
   * stored total -- so a row whose total is not shown must not be added either.
   *
   * Deliberately NOT the server's cumulativeTotal*Price: OrderService::generateOptionStructure()
   * adds a top-level Select's own total to its cumulative a second time, so every such option
   * arrives doubled (order 213773's POS line: totalDealerPrice 25.00, cumulative 50.00, which
   * put the article subtotal 25.00 above the order total). The order PDF reads the same field
   * and is wrong in the same way -- that needs fixing server-side.
   *
   * A rug's Shape/Finishing/Colour options are skipped, because their price is already folded
   * into the rug line's own total.
   */
  private optionSubtreeTotal(option, orderItemProduct): number {
    if (!this.isCalculatable(orderItemProduct) || option.carpetRole) {
      return 0;
    }
    const ownRow = this.checkType(option)
      ? parseFloat(this.isCustomerPrice ? option.totalCustomerPrice : option.totalDealerPrice) || 0
      : 0;

    return (option.children ?? []).reduce(
      (total, child) => Helper.bcAdd(total, this.optionSubtreeTotal(child, orderItemProduct)),
      ownRow,
    );
  }

  private prepareOrder(order) {
    // This screen indexes the response by ELEMENT (orderItemProduct id) just below, so a
    // quote has to be asked for the per-element shape too. It used to take the merged,
    // article-keyed default, and because element and article ids come from different
    // tables and can collide, an article's whole merged option list surfaced under one
    // element - a rug quote showed every element's options under a single carpet (C7).
    const requestOption = this.isQuote ?
      this.orderService.getQuoteOption(this.orderId, true) : this.orderService.getOption(this.orderId);
    requestOption.subscribe(orderItemOptions => {
      order.orderItems.forEach((orderItem) => {
        orderItem.orderItemProducts.forEach((orderItemProduct) => {
          const orderItemProductId = orderItemProduct.id;
          if (orderItemOptions[orderItemProductId] == null) {
            this.options[orderItemProductId] = [];
          } else {
            this.options[orderItemProduct] = [];
            Object.keys(orderItemOptions[orderItemProductId]).forEach(productId => {
              this.options[orderItemProductId] = orderItemOptions[orderItemProductId];
            });
          }
        });
      });
      this.lastOrderCalc(order);
      this.getAllTotal(order);
    });
  }

  hasCustomFabric() {
    let has = false;
    this.order.orderItems.some((orderItem ) => {
      orderItem.orderItemProducts.some((orderItemProduct) => {
        // tslint:disable-next-line:max-line-length
        if ( (orderItemProduct.orderItemProductFabricCollections[0].fabricCollection as FabricCollection) && (orderItemProduct.orderItemProductFabricCollections[0].fabricCollection as FabricCollection).isCustom) {
          has = true;
        }
        return has;
      });
      return has;
    });
    return has;
  }
  isCustomFabric(orderItemProductFabricCollection) {
    return Helper.isDefined(orderItemProductFabricCollection.fabricCollection) &&
      orderItemProductFabricCollection.fabricCollection && orderItemProductFabricCollection.fabricCollection
      && orderItemProductFabricCollection.fabricCollection.isCustom;
  }

  public isCalculatable(orderItemProduct) {
    const option = orderItemProduct.selectedPerProductOption ? orderItemProduct.selectedPerProductOption.urbanOption : null;
    return !(this.isCustomFabric(orderItemProduct.orderItemProductFabricCollections[0]) && option && option.needsFabric) ||
      !this.isCustomFabric(orderItemProduct.orderItemProductFabricCollections[0]);
  }

  public recalculateFabricAmount(orderItemProductFabricCollections, selectedOption, productAmount, orderItemProduct: OrderItemProduct) {
    let fabricAmount = 0;
    const productProperty = typeof orderItemProduct.product === 'object' ? orderItemProduct.product.productProperties.find(item => item.property.code === Property.PROPERTY_FABRIC_STOFVERRUIK) : null;
    if (productProperty) {
      fabricAmount = Number((parseFloat(productProperty.amount) * orderItemProduct.amount).toFixed(2));
    } else {
      fabricAmount = orderItemProductFabricCollections.amount;
    }

    fabricAmount += .25;
    if ( selectedOption && selectedOption.needsFabric && selectedOption.fabricAmount ) {
      fabricAmount +=  productAmount * Number(selectedOption.fabricAmount);
    }
    return fabricAmount;
  }


  private prepareDiscount(order: Order) {

    this.discount.amount = order.discount.amount;
    this.discount.percentage = order.discount.percentage;
    this.discount.description = order.discount.description;
    this.discount.type = order.discount.amount > 0 ? 'amount' : 'percent';
    this.discount.castIt(
      Helper.bcAdd(order.totalCost.totalDealerPrice, this.order.discount.applied),
      order.discount.amount > 0 ?
        order.discount.amount : order.discount.percentage
    );
  }

  getDealerPrice(value: boolean) {
    if (!value) {
      this.selectedCustomPrice = true;
      this.isCustomerPrice = true;
      this.toggleCustomerPriceClass = 'fa-toggle-off';
      this.getAllTotal(this.order);
    } else {
      this.isCustomerPrice = true;
      this.selectedCustomPrice = false;
      this.passwordModal.show();
    }
  }

  getCustomerPrice() {
    this.auth.checkPassword(this.dealerPassword).pipe(catchError(res => this.catchError(res))).subscribe(() => {
      this.passwordModal.hide();
      if (this.dealerPdfOrderId) {
        this.orderService.getPdf(this.dealerPdfOrderId, 'dealer')
        .subscribe((resp) => {
          if (resp && typeof resp === 'object') {
            this.helper.createDownloadLink(resp.url, resp.filename);
          }
        });
        this.dealerPdfOrderId = null;
      } else if (this.quoteDealerPdfRequested) {
        this.orderService.getPdf(this.orderId, 'dealer')
          .subscribe((resp) => {
            if (resp && typeof resp === 'object') {
              this.helper.createDownloadLink(resp.url, resp.filename);
            }
        });
        this.quoteDealerPdfRequested = false;
      } else {
        this.isCustomerPrice = false;
        this.dealerPassword = null;
        this.toggleCustomerPriceClass = 'fa-toggle-on';
        this.getAllTotal(this.order);
      }

      this.passwordModalForm.reset();
    });
  }

  public catchError(response) {
    const body: any = response.error;
    this.helper.popMessageDialog(this.translator.instant('auth.password_is_invalid'), this.translator.instant('auth.password_is_invalid'));
    this.priceItemHasError = true;
    this.passwordModalForm.reset();
    return throwError(body.errors);
  }

  checkPasswordError() {
    this.isCustomerPrice = true;
    this.selectedCustomPrice = true;
    this.passwordModal.hide();
  }

  getQuotePdf() {
    this.orderService.getPdf(this.orderId, 'customer').subscribe((resp) => {
      if (resp && typeof resp === 'object') {
        this.helper.createDownloadLink(resp.url, resp.filename);
      }
    });
  }

  getQuoteDealerPdf() {
    if (this.auth.isDealer()) {
      this.quoteDealerPdfRequested = true;
      this.passwordModal.show();
    }
  }


  editQuote() {
    this.router.navigateByUrl('dealer-system/quote/' + this.orderId + '/edit');
  }

  private addSpecialButtons() {

    if (this.isQuote) {
      this.specialButtonArray.push({
        key: 'edit_quote',
        name: this.translator.instant(this.order.remainingDays >= 0 ? 'global.edit_quote' : 'global.update_quote'),
        method: 'editQuote',
        customClass: 'btn-primary'
      });
      if (!this.auth.isDealerTabletUser() && this.order.remainingDays >= 0) {
        this.specialButtonArray.unshift(
          {
            key: 'place_order',
            name: this.translator.instant('global.place_order'),
            method: 'editQuote',
            customClass: 'btn-grey'
          }
        );
      }

      if (this.order.remainingDays >= 0) {
        this.specialButtonArray.unshift(
          {key: 'quote_pdf', name: this.translator.instant('global.quote_customer_pdf'), method: 'getQuotePdf', customClass: 'btn-grey'}
        );
        if (!this.auth.isDealerUser()) {
          this.specialButtonArray.unshift(
            {key: 'quote_dealer_pdf', name: this.translator.instant('global.quote_dealer_pdf'), method: 'getQuoteDealerPdf', customClass: 'btn-grey'}
          );
        }

      }
    } else {
      if (this.isEditableAfterCancel) {
        this.specialButtonArray.push({
          key: 'edit_order',
          name: this.translator.instant('doctrine.order.edit_order'),
          method: 'goToEditOrder',
          customClass: 'btn-primary'
        });
      }
      this.specialButtonArray.unshift(
        {
          key: 'pdf',
          name: this.translator.instant('global.order_pdf_customer'),
          method: 'orderPdf',
          customClass: 'btn-grey'
        }
      );
      if (!this.auth.isDealerUser()) {
        this.specialButtonArray.unshift(
          {key: 'pdf', name: this.translator.instant('global.order_pdf_dealer'), method: 'orderDealerPdf', customClass: 'btn-grey'}
        );
      }
      // NOTE: uncomment this if you want service button to be rendered with condition
      // if (this.auth.isDealer() && this.order.status !== Order.COMPLETED.key) {
      //   this.specialButtonArray.unshift(
      //     {key: 'service', name: this.translator.instant('global.services'), method: 'requestNewService', customClass: 'btn-grey'}
      //   );
      // }
      if (this.order.status !== Order.CANCELLED.key && this.order.status !== Order.CHANGED.key) {
        this.specialButtonArray.unshift(
          {key: 'service', name: this.translator.instant('global.services'), method: 'requestNewService', customClass: 'btn-grey'}
        );
      }
    }

    if (!this.isQuote && this.order.status !== Order.CANCELLED.key) {
      this.specialButtonArray.unshift({
        key: 'cancel_order',
        name: this.translator.instant('doctrine.order.cancel_order'),
        method: 'showCancelModal',
        customClass: 'btn-grey'
      });
    }

    this.specialButtonArray.forEach(items => {
      this.specialButton.push({
        key: items.key,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });
    });
  }

  /**
   * A carpet line's product row shows the rug's MATERIAL amount, in whichever price scope
   * is on: shape and finishing render their own rows underneath it, so repeating the
   * combined line total there reads as if the rug itself cost the whole line.
   *
   * `unit` is derived rather than served separately - it differs from the total only by the
   * line's amount, since every option total is its own per-unit cost times that amount.
   * A sofa line, or a carpet line whose stored total is unusable, has no material figure
   * and falls back to exactly what it shows today.
   */
  carpetUnitPrice(orderItemProduct): number {
    const material = this.isCustomerPrice
      ? orderItemProduct.carpetMaterialCustomerPrice
      : orderItemProduct.carpetMaterialPrice;
    if (material === undefined || material === null) {
      return this.isCustomerPrice ? orderItemProduct.cost.customerPrice : orderItemProduct.cost.dealerPrice;
    }
    const amount = orderItemProduct.amount > 0 ? orderItemProduct.amount : 1;

    return material / amount;
  }

  /** The same figure as a line total - what the row's Total column shows. */
  carpetLineTotal(orderItemProduct): number {
    const material = this.isCustomerPrice
      ? orderItemProduct.carpetMaterialCustomerPrice
      : orderItemProduct.carpetMaterialPrice;
    if (material === undefined || material === null) {
      return this.isCustomerPrice ? orderItemProduct.totalCost.totalCustomerCost : orderItemProduct.totalCost.totalDealerPrice;
    }

    return material;
  }
}
